<div id="chapps-card">
  <div id="chapps-card-body" class="d-flex justify-content-start align-items-center p-3">
    <div class="ml-3">
      <div class="mb-2"><strong>{{userName}}</strong></div>
      <div class="pl-0">{{userEmail}}</div>
    </div>
  </div>
  <div class="divider dropdown-divider"></div>
  <div>
    <a class="dropdown-item waves-light"  (click)="onSignOutClick()">
      <i class="fa fa-sign-out mr-1"></i>
      <span>{{ Localization.SignOut | translate}}</span>
    </a>
  </div>
</div>